import React, { memo, forwardRef } from "react";
const SvgForall = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M8.914 6.594a1 1 0 00-1.827.813l8 18a1 1 0 001.827 0l8-18a1 1 0 00-1.827-.813L19.795 14h-7.59l-3.29-7.406zM13.094 16L16 22.538 18.906 16h-5.811z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgForall.displayName = "SvgForall";
const MemoForwardRef = memo(SvgForall);
export default MemoForwardRef;
